// Self Assign — a custom-body popup (see DynamicPopup's config.component
// escape hatch). SelfAssignBody fetches GET /self-assign and renders either a
// simple confirmation or the "Team Members Allocated" table + warning, and owns
// its own No/Yes footer + submit. Admin lists this by popupKey "self-assign".
import SelfAssignBody from './SelfAssignBody.jsx';

export const config = {
  title: 'Self Assign',
  width: 480,
  className: 'self-assign-modal',
  component: SelfAssignBody,
};
